import { ChevronLeft } from "lucide-react";
import React from "react";

export default function MenuHeader2({
  logo,
  hasBack = false,
  title = "Main Menu",
  onBack,
  onClose,
}) {
  return (
    <div className="header-2">
      <div className="header-left-2">
        {hasBack ? (
          <button className="btn-back-2" onClick={onBack}>
            <ChevronLeft size={18} className="back-2-icon" />
            <span className="header-title-2">{title}</span>
          </button>
        ) : (
          logo && (
            <a href="/" className="header-logo-2">
              <img src={logo} alt="Logo" />
            </a>
          )
        )}
      </div>
    </div>
  );
}
